export { elasticApmAnalytics } from './elasticApm';
